/*
 * "Read more" under the description summary: glide down to the full description and
 * open it.
 *
 * The description is a collapsible row, so a plain anchor jump would land on a closed
 * heading - the row is opened first. The stop point allows for the header only when it
 * is set to stay visible (the default hides it while scrolling down, which is the
 * direction this always scrolls).
 *
 * One delegated listener, guarded, because the product section is re-rendered in the
 * theme editor and on variant changes and would otherwise pick up a second copy.
 */
(function () {
  if (window.pierzelDescriptionReadMore) return;
  window.pierzelDescriptionReadMore = true;

  var GAP = 16;

  function pinnedHeight() {
    var height = 0;

    var sticky = document.querySelector('sticky-header');
    var type = sticky && sticky.getAttribute('data-sticky-type');
    if (type === 'always' || type === 'reduce-logo-size') {
      var header = document.querySelector('.section-header');
      if (header) height += header.offsetHeight;
    }
    return height;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-description-read-more]');
    if (!link) return;

    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return; // leave it to the browser rather than swallowing the click

    event.preventDefault();

    var details = target.matches('details') ? target : target.querySelector('details');
    if (details && !details.open) details.open = true;

    var top = target.getBoundingClientRect().top + window.pageYOffset - pinnedHeight() - GAP;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduced ? 'auto' : 'smooth' });

    // Move focus with the reader, without letting the browser jump ahead of the glide.
    var focusTarget = (details && details.querySelector('summary')) || target;
    if (!focusTarget.hasAttribute('tabindex') && focusTarget.tagName !== 'SUMMARY') {
      focusTarget.setAttribute('tabindex', '-1');
    }
    focusTarget.focus({ preventScroll: true });
  });
})();
